/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import './style/loader.scss';

import React, {CSSProperties, useMemo} from 'react';
import classNames from 'classnames';
import {ThemeShape} from '../util/controlContext';
import {isNull} from "../util/controlUtil";
import {colorIsWhite, convertColor} from "../util/colorUtil";

interface Props {
    label?: string,
    size?: string,
    thickness?: string,
    baseColor: string,
    trackColor: string,
    className?: string,
    loaderClassName?: string,
    labelClassName?: string,
    contextStyle: ThemeShape,
    disableBackground?: boolean,
    loaderStyle?: CSSProperties;
    position: 'absolute' | 'fixed' | 'relative';
}

export default function Loader(props: Props) {
    const {
        loaderClassName, labelClassName, loaderStyle, label, className, contextStyle, disableBackground, size,
        thickness, trackColor, baseColor, position
    } = props;
    const _className = useMemo(() => {
        const classes: Array<string> = ['loader-container'];
        if (disableBackground) classes.push('no-back');
        if (className) classes.push(className);
        return classNames(classes);
    }, [className, disableBackground]);
    const _loaderStyle = useMemo(() => {
        let color = isNull(baseColor) ? 'color-orange-1' :
            colorIsWhite(baseColor) ? contextStyle.contrastColor : baseColor;
        const track = isNull(trackColor) ? 'color-gray-7' : trackColor;
        let style: CSSProperties = {borderColor: convertColor(track), borderTopColor: convertColor(color)};
        if (!!size) {
            style.width = size;
            style.height = size;
            style.paddingBottom = 'unset';
        }
        if (!!thickness)
            style.borderWidth = thickness;
        return {...style, ...(loaderStyle ?? {})};
    }, [baseColor, contextStyle.contrastColor, trackColor, size, thickness, loaderStyle]);

    function renderLabel() {
        if (!label) return null;
        return <label className={classNames('loader-label', labelClassName)}>{label}</label>
    }

    return (
        <div className={_className} style={{position}}>
            <div className={classNames('loader', loaderClassName)} style={_loaderStyle}/>
            {renderLabel()}
        </div>
    )
}